import { Checkbox, Input } from 'antd';
import styled from 'styled-components';

export const MainPopupBlockUI = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

export const PopupBlock = styled.div`
  width: 100%;
  padding: 10px;
  max-width: 600px;

  background: white;
  border-radius: 8px;

  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    font-family: Roboto, sans-serif;
    font-size: 24px;
    color: #1272ba;
    text-transform: uppercase;
    font-weight: 500;
    padding-bottom: 35px;
    padding-top: 50px;
  }

  .close {
    font-size: 35px;
    font-weight: 600;
    height: 35px;

    background: none;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    color: #ececec;

    position: absolute;

    right: 15px;
    top: 10px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const LoginForm = styled.div`
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;

  form {
    width: 100%;
  }

  .ant-form-item-control-input-content {
    gap: 5px;
    margin: 0;

    input {
      width: 100%;
    }

    .text {
      color: #1272ba;
      font-size: 15px;
      font-weight: 400;
    }

    .label {
      color: #333;
      font-size: 18px;
    }

    .ant-select-selector {
      border-radius: 100px !important;
      height: 40px !important;
      padding-top: 5px !important;
      padding-left: 10px !important;

      color: #444;
      font-weight: 500;
      font-size: 14px;
    }
  }
`;

export const LoginInput = styled(Input)`
  border-radius: 20px;
  height: 40px;
  width: 100%;
  font-size: 16px;
`;

export const LoginCheckbox = styled(Checkbox)`
  margin-bottom: 12px;

  .ant-checkbox-inner {
    border-radius: 0;
    width: 20px;
    height: 20px;
  }

  span {
    color: #7594b9;
    font-size: 15px;
  }
`;
